import CertificateIssuanceNew from "../../features/CertificateIssuance/CertificateIssuance";
import "./CertificateIssuance.scss";

const CertificateIssuancePage = () => {
  return (
    <div>
      <CertificateIssuanceNew />
    </div>
  );
};

export default CertificateIssuancePage;
